module.exports = __webpack_public_path__ + "img/JS11X5.png";